import requester from '../requester';
import { GET_DESIGN_MATERIAL_URL } from '../../constants';

const DesignMaterial = {
  getDesigns: () => requester.get(GET_DESIGN_MATERIAL_URL)
};

export default DesignMaterial;
